import { useAxios } from "@hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { applyMonitorStateChange } from "../../../components/exam-period/monitor/monitorStateSync";

export const useEditExamInstanceMonitor = () => {

    const axios = useAxios();
    const {t} = useTranslation();
    const queryClient = useQueryClient();

    const editExamInstance = async (examPeriod: any) => {
        try {
            await axios.put(`/api/examinstance/monitor`, examPeriod);
        } catch (error) {
            throw new Error(t("messages.error.editExamInstanceMonitor"));
        }
    }

    return useMutation({
        mutationFn: editExamInstance,
        // INSTANT optimistički update PRIJE nego PUT završi (backend ChangeState zna
        // trajati par sekundi). Bez ovoga monitor na pauzi nastavi teći / na nastavku
        // stoji dok request ne završi. Usklađujemo I state I sync (timer čita `sync`).
        onMutate: async (vars: any) => {
            const monitorKey = ["examPeriods", vars.examId, "monitor"];
            // Zaustavi tekući periodički refetch (15 s) da ne pregazi optimistički update.
            await queryClient.cancelQueries({ queryKey: monitorKey });
            const previous = queryClient.getQueryData(monitorKey);
            queryClient.setQueryData(monitorKey, (old: any) =>
                applyMonitorStateChange(old, vars.ids, vars.newState));
            return { previous, monitorKey };
        },
        // Rollback ako PUT padne.
        onError: (_err, _vars, context: any) => {
            if (context?.previous !== undefined) {
                queryClient.setQueryData(context.monitorKey, context.previous);
            }
        },
        // Autoritativni refetch nakon što se request slegne: donosi precizni
        // (deterministički) endsAt usklađen sa state-om.
        onSettled: (_data, _err, vars: any) => {
            const monitorKey = ["examPeriods", vars.examId, "monitor"];
            queryClient.refetchQueries({ queryKey: monitorKey });
            queryClient.invalidateQueries({ queryKey: ["examPeriods", vars.examId] });
        },
    });
}